// based on vc-align 2.4.5
import Align from './Align';
export default Align;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-align/index.js
// module id = null
// module chunks = 